import React from 'react';
import HelpContent from './HelpContent';

const ImpuestoCarbonoHelp = () => (
  <HelpContent>
    <h1>Impuesto al carbono</h1>
    <p>
      Este instrumento económico tiene como objetivo penalizar las emisiones de gases de efecto
      invernadero mediante la aplicación de un impuesto a instalaciones emisoras.
    </p>
    <h2>Trayectorias disponibles</h2>
    <p>
      <strong>Trayectoria 1:</strong> Se aplica un impuesto de 5 US$/tCO2 a las instalaciones que emiten
      más de 25.000 tCO2 anuales.
    </p>
    <p>
      <strong>Trayectoria 2:</strong> A partir del año 2030 el impuesto se incrementa a 33 US$/tCO2 a
      las instalaciones que emiten más de 25.000 tCO2 anuales.
    </p>
    <p>
      <strong>Trayectoria 3:</strong> A partir del año 2030 el impuesto se incrementa a 78 US$/tCO2
      (equivalente a precio social) a las instalaciones que emiten más de 25.000 tCO2 anuales.
    </p>
  </HelpContent>
);

export default ImpuestoCarbonoHelp;
